import React, { useState, useEffect } from "react";
import Spinner from "../Spinner";
import { fetchOrderTracking } from "../../services/OrderService";
import fullLogo from "../../assets/images/svg/unicornio-brown.svg";

export default function ModalTracking({ data }) {
  const [loading, setLoading] = useState(true);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (data?.orderId) {
      loadTracking(data.orderId);
    }
  }, [data]);

  const loadTracking = async (orderId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchOrderTracking(orderId);
      setTrackingInfo(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const renderHeader = () => (
    <>
      <div className="row justify-content-center">
        <div className="col-auto mb-3 mt-2">
          <img src={fullLogo} alt="Puríssima" style={{ maxHeight: "80px" }} />
        </div>
      </div>
      <h4 className="text-center mb-4"><strong>RASTREAMENTO</strong></h4>
    </>
  );

  if (loading) {
    return (
      <div className="ModalTracking rounded" style={{ backgroundColor: "#E6DDCE", minHeight: "400px" }}>
        <div className="container py-4">
          {renderHeader()}
          <div className="text-center p-4"><Spinner /></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ModalTracking rounded" style={{ backgroundColor: "#E6DDCE", minHeight: "400px" }}>
        <div className="container py-4">
          {renderHeader()}
          <div className="text-center p-4 text-danger">
            <strong>{error}</strong>
          </div>
        </div>
      </div>
    );
  }

  const renderTrackingCode = () => {
    if (!trackingInfo?.tracking_code) return null;
    return (
      <>
        <strong>Código:</strong>{" "}
        <a
          href={trackingInfo?.fallback_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          {trackingInfo.tracking_code}
        </a>
      </>
    );
  };

  if (!trackingInfo || !trackingInfo.events || trackingInfo.events.length === 0) {
    return (
      <div className="ModalTracking rounded" style={{ backgroundColor: "#E6DDCE", minHeight: "400px" }}>
        <div className="container py-4">
          {renderHeader()}
          <div className="text-center mb-3">
            <p className="mb-1">{renderTrackingCode()}</p>
            <small className="text-muted d-block">Enviado via {trackingInfo?.gateway}</small>
          </div>
          <div className="text-center mt-4">
            <p>Ainda não há eventos de rastreio para este pedido.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ModalTracking rounded" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container py-4">
        {renderHeader()}
        
        <div className="mb-4 text-center">
          <p className="mb-1">{renderTrackingCode()}</p>
          <small className="text-muted d-block">Enviado via {trackingInfo.gateway}</small>
        </div>

        <div 
          className="bg-white rounded p-3 text-start mx-auto shadow-sm"
          style={{ 
            maxHeight: "50vh", 
            overflowY: "auto", 
            maxWidth: "600px",
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(0,0,0,0.2) transparent"
          }}
        >
          <ul className="list-unstyled mb-0">
            {trackingInfo.events.map((ev, i) => (
              <li key={i} className="mb-3 pb-3 border-bottom" style={{ borderBottomColor: "#eee" }}>
                <strong>{ev.description}</strong> {ev.comment && <span>- {ev.comment}</span>}
                <br />
                <small className="text-muted d-block">{ev.location}</small>
                <small className="text-muted d-block" style={{ fontSize: "0.85rem" }}>
                  {ev.datetime ? new Date(ev.datetime).toLocaleString('pt-BR') : ""}
                </small>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
